import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { ALL_ITEMS, SORT_TYPE } from '~/shared/constants';
import { initialPageInfo } from '~/shared/store/slices/lessons/lessons-slice';
import type { CourseType } from '~/types';

type CoursesSliceType = {
  course: CourseType;
  isAddCourse: boolean;
  coursesPagination: {
    items: Record<string, unknown>[];
    isLoading: boolean;
    pageInfo: Record<string, unknown>;
  };
  videoCourses: {
    selectedDirection: string;
    selectedSort: string;
  };
  onlineCourses: {
    selectedDirection: string;
    selectedSort: string;
  };
};

const initialState: CoursesSliceType = {
  course: null,
  isAddCourse: false,
  videoCourses: {
    selectedDirection: ALL_ITEMS,
    selectedSort: SORT_TYPE.CREATED_AT_ASC,
  },
  coursesPagination: {
    items: [],
    isLoading: false,
    pageInfo: initialPageInfo,
  },
  onlineCourses: {
    selectedDirection: ALL_ITEMS,
    selectedSort: SORT_TYPE.CREATED_AT_ASC,
  },
};

export const coursesSlice = createSlice({
  name: 'courses',
  initialState,
  reducers: {
    setVideoCoursesSelectedDirection: (state, action: PayloadAction<string>) => {
      state.videoCourses.selectedDirection = action.payload;
    },
    setCourse: (state, action: PayloadAction<CourseType>) => {
      state.course = action.payload;
    },
    setOnlineCoursesSelectedSort: (state, action: PayloadAction<CourseType>) => {
      state.onlineCourses.selectedSort = action.payload;
    },
    setVideoCoursesSelectedSort: (state, action: PayloadAction<CourseType>) => {
      state.videoCourses.selectedSort = action.payload;
    },
    setIsAddCourse: (state, action: PayloadAction<CourseType>) => {
      state.isAddCourse = action.payload;
    },
    setCoursesPagination: (state, action: PayloadAction<CourseType>) => {
      state.coursesPagination = action.payload;
    },
    setOnlineCoursesSelectedDirection: (state, action: PayloadAction<string>) => {
      state.onlineCourses.selectedDirection = action.payload;
    },
  },
});

export const {
  setVideoCoursesSelectedDirection,
  setCoursesPagination,
  setOnlineCoursesSelectedSort,
  setVideoCoursesSelectedSort,
  setIsAddCourse,
  setCoursesPaginationLoading,
  appendCoursesPagination,
  setCourse,
  setOnlineCoursesSelectedDirection,
} = coursesSlice.actions;
